<template>
  <b-modal :active.sync="opened" :full-screen="isFullScreen" width="500px">
    <div v-if="video" class="card">
      <div class="card-content">
        <div class="section-block">
          <span class="title">CREATE GROUP SESSION</span>
        </div>

        <validation-observer
          @submit.prevent="submit"
          v-slot="{ valid }"
          ref="form"
          tag="form"
        >
          <div class="columns tw-mb-8">
            <div class="column is-two-fifths">
              <figure class="image is-4x3">
                <img class="session-cover" v-lazy="video.resource.cover.url" />
              </figure>
            </div>
            <div class="column session-info">
              <div>
                <p
                  class="is-marginless is-size-2 has-text-weight-bold has-text-black session-title"
                >
                  {{ video.title }}
                </p>
                <p class="is-size-5 tw-mt-6">
                  {{ video.description }}
                </p>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <validation-provider
                name="date"
                rules="required"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-datepicker
                    v-model="form.date"
                    placeholder="Choose date"
                    :min-date="minSessionDate"
                    :date-formatter="formatDate"
                    position="is-top-right"
                  >
                  </b-datepicker>
                </b-field>
              </validation-provider>
            </div>
            <div class="column">
              <validation-provider
                name="time"
                rules="required"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-timepicker
                    class="timepicker"
                    v-model="form.time"
                    placeholder="Choose time"
                    :time-formatter="formatTime"
                    position="is-top-right"
                  >
                  </b-timepicker>
                </b-field>
              </validation-provider>
            </div>
          </div>

          <div class="level">
            <div class="level-left"></div>
            <div class="level-right">
              <b-button
                :disabled="!valid || isSubmitting"
                :loading="isSubmitting"
                native-type="submit"
                type="is-primary"
              >
                Create Session
              </b-button>
            </div>
          </div>
        </validation-observer>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ResourceVideo from '@/models/ResourceVideo'
import GroupSession from '@/models/GroupSession'
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import ModalMixin from '@/utils/mixins/modal'

export default {
  mixins: [ModalMixin],
  props: {
    video: {
      type: ResourceVideo
    }
  },
  data() {
    return {
      opened: false,
      isSubmitting: false,
      form: {
        date: null,
        time: null
      }
    }
  },
  computed: {
    ...mapState({
      currentGroup: state => state.currentGroup
    }),
    minSessionDate() {
      return new Date()
    }
  },
  methods: {
    open() {
      this.opened = true
    },

    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD')
    },

    formatTime(time) {
      return dayjs(time).format('HH:mm')
    },

    submit() {
      this.isSubmitting = true
      const session = new GroupSession({
        resource_video_id: this.video.id,
        date: this.formatDate(this.form.date),
        time: this.formatTime(this.form.time)
      })
      session
        .for(this.currentGroup)
        .save()
        .then(response => {
          this.$emit('created')
          this.$buefy.snackbar.open({
            type: 'is-success',
            message: 'Group Session successfully added.',
            position: 'is-top'
          })
          this.form = {
            date: null,
            time: null
          }
          requestAnimationFrame(() => {
            this.$refs.form.reset()
            this.opened = false
          })
        })
        .catch(({ response }) => {
          if (response.data && response.data.errors) {
            this.$refs.form.setErrors(response.data.errors)
          }
        })
        .then(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>
